export class Status {
  statusId
  status

  constructor(status = {}) {
    this.statusId = status.statusId ? String(status.statusId) : ''
    this.status = status.status ? String(status.status) : ''
  }
}